import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

// All user-facing timestamps render in U.S. Central Time (Chicago handles CST/CDT).
export const CENTRAL_TZ = "America/Chicago";

export function formatDate(iso, opts = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", { timeZone: CENTRAL_TZ, year: "numeric", month: "long", day: "numeric", ...opts });
}

export function formatDateTime(iso, opts = {}) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleString("en-US", { timeZone: CENTRAL_TZ, year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short", ...opts });
}

export async function uploadPdf(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, name, size }
}

export async function uploadBill(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/expenses/bill-upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, name, size }
}

export async function uploadDoc(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload/doc", form, { headers: { "Content-Type": "multipart/form-data" } });
  return data; // { path, name, size }
}

export function fileUrl(path) {
  if (!path) return "";
  return `${API}/files/${path}`;
}

export default api;
